import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">MOTIVATION – HOW ARE PEOPLE DIFFERENT?</span>
                                            </div>
                                            <p>Think about your team members or colleagues. You can probably describe
                                                the most obvious differences in the ways they work. Some may be
                                                energised by new ideas and concepts, others by the detail. Some will
                                                come alive talking directly to clients and socialising with colleagues,
                                                then there’ll be those who only light up when it’s time to go home!
                                                While generalisation is a dangerous thing, it’s useful to highlight the
                                                most common characteristics of different types, what their ‘needs’ are
                                                and, therefore, what motivates them. See if you can recognise any of
                                                your team members or colleagues in the descriptions here:</p>

                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left" valign="top"
                                                        width="50%">A Need to Achieve…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">What you’ll see: </span> Outward
                                                            drive, competitive behaviour, impatience with themselves and
                                                            others,
                                                            intolerance of others’ mistakes, always busy. </p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">How to harness it: </span> Set
                                                            stretching targets, give autonomy for results, set
                                                            competitions, set clear
                                                            timescales, avoid ambiguities.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">Watch out for: </span> Burn-out,
                                                            signs of anger, disappointment at failure, over-reactions to
                                                            negative
                                                            feedback, doing too much.</p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left" valign="top"
                                                        width="50%">A Need to Please…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">What you’ll see: </span> React
                                                            positively to feedback, back down quickly in arguments,
                                                            present their results positively.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">How to harness it: </span> Set
                                                            challenging (but reasonable) goals, make the goals visible
                                                            to others, make the goals part of a collective team effort,
                                                            offer praise publicly and regularly.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">Watch out for: </span> Individuals
                                                            becoming too compliant, being easily upset by criticism,
                                                            putting others ahead of own needs &amp; being over-sensitive
                                                            to negative feedback.</p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left" valign="top"
                                                        width="50%">A Need to Belong…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">What you’ll see: </span> Highly
                                                            sociable, eager to talk to others, enjoy team working,
                                                            adaptable, outwardly
                                                            friendly and cohesive style, a ‘team’ person.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">How to harness it: </span> Include
                                                            in team activities, giving people-focused responsibilities,
                                                            create
                                                            opportunity to build relationships.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">Watch out for: </span> Being
                                                            easily distracted, difficulty working independently, being
                                                            over-sensitive to
                                                            relationship challenges.</p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left" valign="top"
                                                        width="50%">A Need for Autonomy…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">What you’ll see: </span> High
                                                            independence, desire for freedom, self-management,
                                                            controlling behaviours,
                                                            tendency to work outside the rules.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">How to harness it: </span> Break
                                                            tasks into separate chunks, provide management
                                                            responsibilities, agree
                                                            overall targets (not every step).</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top" width="50%">
                                                        <div className="paraspace"><p><span className="subtiltereg">Watch out for: </span> Lack
                                                            of communication, detachment from teams, over-controlling
                                                            behaviour.</p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page3')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page5')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}